module.exports = __webpack_public_path__ + "assets/img/carousel-2-1280.c1036cca.webp";